export default __webpack_public_path__ + "static/media/anuvadak-login-logo.7830cecc.png";